import {
  DEACTIVATE_PROCESS_END_FOR_SETUP_FEES,
  DEACTIVATE_PROCESS_START_FOR_SETUP_FEES,
  CANCEL_DEACTIVATE_MODAL_FOR_SETUP_FEES,
  DISPLAY_DEACTIVATE_MODAL_FOR_SETUP_FEES,
  SET_EVENT_TYPES_IN_STATE_FOR_SETUP_FEES,
  DISPLAY_NEW_FEE_FOR_SETUP,
  CANCEL_FEE_FORM_FOR_SETUP,
  DISPLAY_INACTIVE_FEES_FOR_SETUP,
  DISPLAY_ACTIVE_FEES_FOR_SETUP
} from './constants';

export const deactivateProcessEnd = () => ({
  type: DEACTIVATE_PROCESS_END_FOR_SETUP_FEES
});

export const deactivateProcessStart = () => ({
  type: DEACTIVATE_PROCESS_START_FOR_SETUP_FEES
});

export const cancelDeactivateModal = () => ({
  type: CANCEL_DEACTIVATE_MODAL_FOR_SETUP_FEES
});

export const displayDeactivateModal = feeItem => ({
  type: DISPLAY_DEACTIVATE_MODAL_FOR_SETUP_FEES,
  payload: feeItem
});

export const setEventTypesInState = eventTypes => ({
  type: SET_EVENT_TYPES_IN_STATE_FOR_SETUP_FEES,
  payload: eventTypes
});

export const displayNewFee = () => ({
  type: DISPLAY_NEW_FEE_FOR_SETUP
});

export const cancelFeeItemForm = () => ({
  type: CANCEL_FEE_FORM_FOR_SETUP
});

export const displayInactiveFees = inactiveFees => ({
  type: DISPLAY_INACTIVE_FEES_FOR_SETUP,
  payload: inactiveFees
});

export const displayActiveFees = activeFees => ({
  type: DISPLAY_ACTIVE_FEES_FOR_SETUP,
  payload: activeFees
});



// WEBPACK FOOTER //
// ./src/features/tournament/fees/actionTypes.js